import React from 'react'

import PrintScore from './PrintScore'

export default class PrintScanScores extends React.Component {

  getPhaseScoreIndicator(pt, i) {
    const tableStyle = {
      fontSize: 10 + 'px'
    }

    return (
      <tr key={i}>
        <td width="60%"><span className="text">{pt.phase}</span></td>
        <td width="40%" style={tableStyle}><PrintScore score={pt.score} /></td>
      </tr>
    )
  }

  render() {
    const { scan, wheelTotals, phaseTotals } = this.props
    const tableStyle = {
      fontSize: 10 + 'px'
    }

    return (
      <div className="result-scores">
        <div className="scan-container">
          <h2>Toelichting scores</h2>
          { this.props.type === "analysis" && <div style={{fontSize: '15px', lineHeight: '1.3em'}}><p><strong>Opmerking:</strong> onderstaande scores geven de bijgewerkte waarden weer, op basis van hetgeen er aangepast is in de analyse. Om de oorspronkelijke waarden te vergelijken, dient u de uitgebreide PDF vanuit het resultatenscherm te downloaden.</p></div> }
          <div className="scan-section total-score">
            <h2>Totaalscore</h2>
            <div style={{fontSize: '11px', fontStyle: 'italic', lineHeight: '1.4em'}}>
              <p>Dit is de totaalscore van de scan ten opzichte van de norm. Het referentie kader voor de norm is bepaald door het vaststellen van een maatgevend scenario en vervolgens te bepalen welk risico redelijkerwijs acceptabel is. Voor een toelichting hiervan, zie Account - Over BrandWijzer - Verantwoording</p>
            </div>
            <table style={tableStyle} width="100%">
              <tbody>
                <tr>
                  <td width="60%"><span>&nbsp;</span></td>
                  <td width="40%">Score</td>
                </tr>
                <tr>
                  <td><span>&nbsp;</span></td>
                  <td style={tableStyle}><PrintScore score={scan.totalScore} /></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="scan-section">
            <h2>Score per stuurwielonderdeel</h2>
            <div style={{fontSize: '11px', fontStyle: 'italic', lineHeight: '1.4em'}}>
              <p>Dit is de score per onderdeel van het Stuurwiel Risicogestuurde Brandveiligheid. Het stuurwiel toont de samenhang tussen alle risicogebieden en maatregelen. Voor een toelichting hiervan, zie Account - Over BrandWijzer - Verantwoording</p>
            </div>
            <table style={tableStyle} width="100%">
              <tbody>
                <tr>
                  <td width="60%"><span>&nbsp;</span></td>
                  <td width="40%">Score</td>
                </tr>
                { wheelTotals.map((wt, i) => 
                  <tr key={i}>
                    <td width="60%"><span><span className="bar-label">{wt.steeringWheel}</span></span></td>
                    <td width="40%" style={tableStyle}><PrintScore score={wt.score} /></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="scan-section">
            <h2>Score per fase</h2>
            <div style={{fontSize: '11px', fontStyle: 'italic', lineHeight: '1.4em'}}>
              <p>Hier ziet u de scores per ontwikkelfase bij een brand, achtereenvolgens Ontstaan van brand, Brandontwikkeling en rookverspreiding, Ontruiming en Continu&#239;teit van zorg.</p>
            </div>
            <table style={tableStyle} width="100%">
              <tbody>
                <tr>
                  <td width="60%"><span>&nbsp;</span></td>
                  <td width="40%">Score</td>
                </tr>
                { phaseTotals.map((pt, i) =>
                 pt.score !== null && this.getPhaseScoreIndicator(pt, i)
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PrintScanScores.js